<template>
    <el-cascader :value="normalizedValue" @input="onInput" :options="tree" :props="props"
                 :show-all-levels="false" v-bind="$attrs"></el-cascader>
</template>

<script>
    import userService from '../../service/user'

    export default {
        name: "UserGroupSelect",
        props: {
            value: [Object, Number, String, Array],
            valueType: {
                type: String,
                default: 'name',
                validator: function (value) {
                    return ['name', 'id', 'object'].indexOf(value) !== -1
                }
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        inheritAttrs: false,
        data() {
            return {
                tree: [],
                userGroups: []
            }
        },
        computed: {
            normalizedValue() {
                if (!this.value) {
                    return null
                }
                if (Array.isArray(this.value)) {
                    return this.valueType === 'object' ? this.value.map(v => v.id) : this.value
                } else {
                    return this.valueType === 'object' ? this.value.id : this.value
                }
            },
            props() {
                return {
                    multiple: this.multiple,
                    value: this.valueType === 'object' ? 'id' : this.valueType,
                    label: 'name',
                    checkStrictly: true,
                    emitPath: false
                }
            }
        },
        created() {
            userService.getVisibleUserGroups().then(response => {
                const rootNodes = []
                for (const row of response.data) {
                    if (row.parent) {
                        let found
                        for (const parent of response.data) {
                            if (parent.id === row.parent.id) {
                                if (parent.children) {
                                    parent.children.push(row)
                                } else {
                                    parent.children = [row]
                                }
                                found = true
                                break
                            }
                        }
                        if (!found) {
                            rootNodes.push(row)
                        }
                    } else {
                        rootNodes.push(row)
                    }
                }
                this.tree = rootNodes
                this.userGroups = response.data
            })
        },
        methods: {
            onInput(newValue) {
                let emitValue
                if (!newValue) {
                    emitValue = null
                } else if (Array.isArray(newValue)) {
                    if (this.valueType === 'object') {
                        emitValue = newValue.map(id => {
                            for (const userGroup of this.userGroups) {
                                if (userGroup.id === id) {
                                    return userGroup
                                }
                            }
                            return {id: id, name: '用户组' + id}
                        })
                    } else {
                        emitValue = newValue
                    }
                } else {
                    if (this.valueType === 'object') {
                        for (const userGroup of this.userGroups) {
                            if (userGroup.id === newValue) {
                                emitValue = userGroup
                                break
                            }
                        }
                        if (!emitValue) {
                            emitValue = {id: newValue, name: '未知用户组' + newValue}
                        }
                    } else {
                        emitValue = newValue
                    }
                }
                this.$emit('input', emitValue)
            }
        }
    }
</script>
